import React from "react";
import {Badge} from "react-bootstrap";
import * as t from "counterpart";

function ProductBadges({product})
{
    return (
        <div className="badges" style={{position: "absolute",  display: "flex", flexWrap: "wrap",  top: 0, right: 0}}>
            {!!product.saved_amount && <Badge pill bg="danger">{t("saved_amount")} <span className="percent">{product.saved_percent} ٪</span> <span className="amount">{product.saved_amount} {window.portalSetting("commerce.currency")}</span> </Badge>}
            {product.available_stock < 6 && <Badge bg="info">{t("Available")} {product.available_stock} </Badge>}
            {!!product.gifts_ids && <Badge bg="info">{t("Gift")} </Badge>}
            {!!product.cash_back && <Badge bg="warning" style={{float: "right"}}>{t("With %(amount)s %(currency)s cashback", {amount: product.cash_back, currency: window.portalSetting("commerce.currency")})} </Badge>}
            {product.labels?.map((label, i) => <Badge key={i} bg="success" style={{float: "right"}}>{label} </Badge>)}
        </div>
    )
}

export default ProductBadges;
